module.exports = __webpack_public_path__ + "img/quotes.af90c171.jpg";